import React from 'react';

import { useHistory } from 'react-router';

import { PlusOutlined } from '@ant-design/icons';
import { CustomerType, TenantFeatureFlag } from '@recurrency/core-api-schema/dist/common/enums';

import { Button } from 'components/Button';

import { useGlobalApp } from 'hooks/useGlobalApp';

import { shouldShowFeatureFlag } from 'utils/roleAndTenant';
import { routes } from 'utils/routes';
import { track, TrackEvent, CtaName, CtaType } from 'utils/track';

export const NewCustomerButton = () => {
  const history = useHistory();
  const { activeTenant, activeUser } = useGlobalApp();

  const newCustomer = () => {
    track(TrackEvent.Nav_CtaClick, {
      ctaName: CtaName.NewCustomer,
      ctaType: CtaType.Button,
    });
    history.push(routes.sales.customerNew({ type: CustomerType.Customer }));
  };
  return shouldShowFeatureFlag(activeTenant, activeUser, TenantFeatureFlag.SalesCreateCustomer) ? (
    <Button type="primary" onClick={newCustomer} icon={<PlusOutlined />}>
      New Customer
    </Button>
  ) : null;
};
